import { motion } from "framer-motion";
import "./Operational.css";

import i1 from "./assets/a1.svg";
import i2 from "./assets/a2.svg";
import i3 from "./assets/a3.svg";
import i4 from "./assets/a4.svg";
import i5 from "./assets/a5.svg";

const OperationalBenefits = () => {
  const data = [
    {
      id: "planning-efficiency",
      title: "Planning Efficiency",
      text: "Automation tools enable quick and accurate planning and assignment of equipment to work points.",
      icon: i1,
    },
    {
      id: "vessel-planning",
      title: "Vessel Planning",
      text: "JIVIEWS tracks vessel work, equipment, and resources for efficient performance reporting.",
      icon: i2,
    },
    {
      id: "equipment-maintenance",
      title: "Equipment Maintenance",
      text: "Ensures only available equipment is deployed, preventing scheduling errors and operational disruptions.",
      icon: i3,
    },
    {
      id: "planning-optimization",
      title: "Planning Optimization",
      text: "Real-time equipment data helps planners maximize utilization using effective resource and manning strategies.",
      icon: i4,
    },
    {
      id: "continuous-productivity",
      title: "Continuous Productivity Improvement",
      text: "Access to performance data enables better planning, reducing idle time and improving productivity.",
      icon: i5,
    },
  ];

  return (
    <motion.div
      className="benefits-container"
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      {/* Title */}
      <motion.h2
        className="benefits-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
        viewport={{ once: true }}
      >
        How it benefits your organization?
        <br />
        Discover more JIVIEWS features
      </motion.h2>

      {/* Cards */}
      <motion.div
        className="benefits-grid"
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
        viewport={{ once: true }}
      >
        {data.map((item, index) => (
          <motion.div
            key={item.id}
            className="electric-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 + index * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="electric-border" />

            <div className="electric-content">
              <div className="icon-wrapper">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="electric-icon"
                />
              </div>

              <h3 className="card-title">{item.title}</h3>
              <p className="card-text">{item.text}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default OperationalBenefits;
